export const BANK_COUNTRY_OPTIONS = [{ value: 'us', label: 'United States' }];

export const CURRENCY_OPTIONS = [{ value: 'usd', label: 'US Dollars' }];
